import { ReportSubscription } from '@/@types/report-subscription';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import {
  REPORT_SUBSCRIPTION_FREQUENCY_LABELS,
  REPORT_SUBSCRIPTION_TYPE_LABELS,
} from '@/modules/report-subscriptions/constants';
import { Chip, Typography } from '@mui/material';
import { ReportSubscriptionsTableActions } from './ReportSubscriptionsTableActions';

export const ReportSubscriptionsTableColumns: ColumnDefinitionType<ReportSubscription>[] =
  [
    {
      key: 'user',
      header: 'Usuário',
      sort: 'user.name',
      render: (reportSubscription) => (
        <>
          <Typography variant="body2">
            {reportSubscription.user?.name || '-'}
          </Typography>
          <Typography variant="body2" color="GrayText" component="span">
            {reportSubscription.user?.email || ''}
          </Typography>
        </>
      ),
    },
    {
      key: 'reportType',
      header: 'Relatório',
      sort: 'report_type',
      render: (reportSubscription) =>
        REPORT_SUBSCRIPTION_TYPE_LABELS[reportSubscription.reportType],
    },
    {
      key: 'frequency',
      header: 'Frequência',
      sort: 'frequency',
      render: (reportSubscription) =>
        REPORT_SUBSCRIPTION_FREQUENCY_LABELS[reportSubscription.frequency],
    },
    {
      key: 'isActive',
      header: 'Status',
      sort: 'is_active',
      render: (reportSubscription) => (
        <Chip
          size="small"
          color={reportSubscription.isActive ? 'success' : 'default'}
          label={reportSubscription.isActive ? 'Ativo' : 'Inativo'}
        />
      ),
    },
    {
      key: 'createdAt',
      header: 'Criado em',
      sort: 'created_at',
    },
    {
      key: 'id',
      header: 'Ações',
      render: ReportSubscriptionsTableActions,
      width: '5rem',
      align: 'center',
      sticky: 'right',
    },
  ];
